/**
 * Web Style Import
 *
 */

import './style/dnb-badge.scss'
